export * from './constants'
export * from './genericMappings'
export * from './notes'
export * from './parents'
export * from './suggestIcons'
export * from './types'
export * from './userGroups'
export * from './users'

import type { SearchErrorResponse } from './types'

export function isSearchErrorResponse(
  responseData: unknown
): responseData is SearchErrorResponse {
  const searchErrorData = responseData as SearchErrorResponse
  if (
    typeof searchErrorData.id === 'string' &&
    typeof searchErrorData.message === 'string' &&
    typeof searchErrorData.status === 'number' &&
    !Number.isNaN(searchErrorData.status)
  ) {
    return true
  }
  return false
}
